module.exports = __webpack_public_path__ + "static/25-ddc7bfc91c420ab817d27d8f1f0f0e53.png";